import { SITE } from "../data/site";
import OrentisLogo from "./OrentisLogo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative border-t border-white/10 px-6 md:px-10 py-16 md:py-24 bg-[var(--bg)]"
      data-testid="site-footer"
    >
      {/* Full logo lockup — replaces the wordmark text */}
      <div className="mx-auto max-w-[1600px] flex flex-col items-center text-center pb-12 md:pb-16 border-b border-white/10">
        <OrentisLogo size="xl" showTag showTagline layout="stack" />
      </div>

      <div className="mx-auto max-w-[1600px] grid grid-cols-12 gap-6 items-start mt-12 md:mt-16">
        <div className="col-span-12 md:col-span-4 text-[11px] tracking-[0.3em] uppercase text-[var(--ink-mute)] leading-[1.9]">
          <div className="mb-2 text-[var(--ink-dim)]">Office of the Founding Partner</div>
          <div className="text-[var(--ink)] tracking-[0.2em]">Dinkar Chopra</div>
        </div>

        <div className="col-span-6 md:col-span-3 text-[12px] tracking-[0.2em] uppercase text-[var(--ink-dim)]">
          <div className="text-[10px] tracking-[0.3em] text-[var(--ink-mute)] mb-3">
            Contact
          </div>
          <a
            href={`mailto:${SITE.contact.email}`}
            className="block hover:text-[var(--gold)] transition-colors duration-300 normal-case tracking-normal text-[13px]"
          >
            {SITE.contact.email}
          </a>
          <a
            href={`tel:${SITE.contact.phoneRaw}`}
            className="block hover:text-[var(--gold)] transition-colors duration-300 normal-case tracking-normal text-[13px] mt-1"
          >
            {SITE.contact.phone}
          </a>
        </div>

        <div className="col-span-6 md:col-span-3 text-[12px] tracking-[0.2em] uppercase text-[var(--ink-dim)]">
          <div className="text-[10px] tracking-[0.3em] text-[var(--ink-mute)] mb-3">
            Elsewhere
          </div>
          <a
            href={SITE.contact.linkedin}
            target="_blank"
            rel="noreferrer"
            className="block hover:text-[var(--gold)] transition-colors duration-300 normal-case tracking-normal text-[13px]"
          >
            LinkedIn
          </a>
        </div>

        <div className="col-span-12 md:col-span-2 text-right text-[10px] tracking-[0.3em] uppercase text-[var(--ink-mute)]">
          © {year} Orentis
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] mt-10 md:mt-14 pt-6 border-t border-white/5 flex items-center justify-between text-[10px] tracking-[0.3em] uppercase text-[var(--ink-mute)]">
        <span>An Independent Consultancy</span>
        <span className="hidden md:inline">Crafted with intent.</span>
        <span>All Rights Reserved</span>
      </div>
    </footer>
  );
}
